import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const GEO_CHECKED_KEY = 'osperb_geo_checked';
const PREFERRED_LANG_KEY = 'osperb_lang_pref';

export default function useGeoRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const checkedRef = useRef(
    sessionStorage.getItem(GEO_CHECKED_KEY) === 'true' || 
    localStorage.getItem(PREFERRED_LANG_KEY) !== null
  );

  useEffect(() => {
    if (checkedRef.current) return;

    const checkGeo = async () => {
      try {
        const res = await fetch('https://get.geojs.io/v1/ip/geo.json');
        if (!res.ok) throw new Error('Network response was not ok');
        const data = await res.json();
        
        sessionStorage.setItem(GEO_CHECKED_KEY, 'true');
        checkedRef.current = true;

        if (data.region === 'Kerala') {
          // If accessing without explicit ML path, redirect to ML version
          if (!location.pathname.startsWith('/ml')) {
             const newPath = '/ml' + (location.pathname === '/' ? '' : location.pathname);
             navigate(newPath + location.search + location.hash, { replace: true });
          }
        }
      } catch (err) {
        console.error('Geo detect failed', err);
        sessionStorage.setItem(GEO_CHECKED_KEY, 'true');
        checkedRef.current = true;
      }
    };

    checkGeo();
  }, [location, navigate]);
}
